import { api } from 'constants/constant';
import { getHeaders } from 'auth/auth';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const passwordAPI = createApi({
  reducerPath: 'updatePassword',
  baseQuery: fetchBaseQuery({ baseUrl: api, credentials: 'include' }),
  endpoints: (builder) => ({
    // update password
    updatePassword: builder.mutation({
      query: ({ data }) => {
        return {
          url: `b2b/user/change_password`,
          method: 'POST',
          body: data,
          headers: getHeaders(),
        };
      },
    }),

    resendEmail: builder.mutation({
      query: ({ data, token }) => {
        const payload = { ...data };
        if (token) {
          payload.session_token = token;
          payload.sessionToken = token;
        }
        return {
          url: `b2b/user/resend-mail`,
          method: 'POST',
          body: payload,
          headers: getHeaders(),
        };
      },
    }),

    updateProfileInfo: builder.mutation({
      query: ({ data, token }) => {
        const payload = { ...data };
        if (token) {
          payload.session_token = token;
          payload.sessionToken = token;
        }
        return {
          url: `b2b/user/personal-info`,
          method: 'POST',
          body: payload,
          headers: getHeaders(),
        };
      },
    }),
  }),
});

export const {
  useUpdatePasswordMutation,
  useUpdateProfileInfoMutation,
  useResendEmailMutation,
} = passwordAPI;
